import { formatDate } from "../../../utilities/formatDate";

// Utilitários compartilhados pelas telas do novo admin

export const redirectIfUnauthorized = (e) => {
  const status = e?.response?.status ?? e?.status;
  if (status === 401 || status === 403) {
    localStorage.removeItem("__extraconomy_token");
    localStorage.removeItem("__extraconomy_username");
    window.location.replace("/login");
    return true;
  }
  return false;
};

// Minúsculas e sem acentos, para buscas tolerantes
export const normalizeText = (value) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const buildSearchText = (values) => normalizeText(values.filter(Boolean).join(" "));

// dd/mm/aaaa em UTC (igual ao formatDate do projeto), com "—" para data ausente ou inválida
export const formatDay = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : formatDate(value);
};

export const getToken = () => localStorage.getItem("__extraconomy_token");
export const getAdminUsername = () => localStorage.getItem("__extraconomy_username");
